import {
  AdvancedFilterInputSchema,
  fulfillmentGroupFilterNames,
} from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getFulfillmentGroupUniqueValues = {
  name: "getFulfillmentGroupUniqueValues" as const,
  input: AdvancedFilterInputSchema.extend({
    filterName: createEnum(fulfillmentGroupFilterNames),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
